export default __webpack_public_path__ + "static/thebottomline2-7197a732e1f123c8d0a8d27c95a9c73c.jpg";